import React from 'react';
import PropTypes from 'prop-types';
import InnerHTML from '@Components/InnerHTML';

function DocumentAbstractComponent({ abstractText, closeClick }) {
  return (
    <div className="result-detail-panel result-detail-abstract">
      <div className="result-detail-panel-wrapper">
        <h4>Abstract</h4>
        <InnerHTML tag="div" className="result-detail-block typography-small" html={abstractText} />
        <button
          type="button"
          tabIndex={0}
          className="els-btn els-btn-modal-close e2e-close"
          onClick={closeClick}
          aria-label="Close abstract">
          <svg className="els-btn-icon els-btn-icon-tiny">
            <use xlinkHref="#icon-delete" />
          </svg>
        </button>
      </div>
    </div>
  );
}

DocumentAbstractComponent.propTypes = {
  abstractText: PropTypes.string.isRequired,
  closeClick: PropTypes.func.isRequired,
};

export default DocumentAbstractComponent;
